import * as React from 'react';

import InputMask from 'react-input-mask';

import { cn } from '../lib/utils/utils';
import { Label } from './label';

interface Props extends React.ComponentProps<'input'> {
  // VariantProps<typeof inputVariants>
  error?: string;
  mask: string;
  alwaysShowMask?: boolean;
  maskChar?: string;
}

const maskOptions = {
  maskChar: '-',
  formatChars: {
    '#': '[0-9]',
    '?': '[0-9]',
  },
};
// TODO DEPRECATED use Input with mask prop instead

const MaskedInput = React.forwardRef<HTMLInputElement, Props>(
  (
    { className, type, placeholder, error, variant = 'default', ...props },
    ref,
  ) => {
    return (
      <Label className={cn('relative', className)} htmlFor={props.id}>
        <InputMask
          type={type}
          // className={cn(inputVariants({ variant }), {
          //   'border-negative-500': !!error,
          //   'pt-0 focus:bg-base-100': variant === 'dashboard',
          // })}
          placeholder={variant === 'dashboard' ? placeholder : ' '}
          formatChars={maskOptions.formatChars}
          maskChar={props.maskChar ?? maskOptions.maskChar}
          inputRef={ref}
          {...props}
        />
        {variant === 'default' && (
          <span
            className={cn(
              'pointer-events-none absolute left-4 top-[14px] origin-[0] -translate-y-3 scale-75 text-base font-normal text-base-300 duration-150 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-autofill:-translate-y-3 peer-autofill:scale-75 peer-focus:-translate-y-3 peer-focus:scale-75',
            )}
          >
            {placeholder}
          </span>
        )}
      </Label>
    );
  },
);
MaskedInput.displayName = 'Input';

export { MaskedInput };
